import * as CONSTANTS from '../constants/constants';

export const getTC = () => (
  dispatch,
  getState,
  { getFirestore }
) => {
  // console.log(userId)
  const firestore = getFirestore();
  const tcRef = firestore.collection(CONSTANTS.THEME).doc('termscondition');
  
  tcRef.get().then((snapshot) => {
    const tcContent = Object.assign(snapshot.data(), { id: snapshot.id });
    dispatch({ type: CONSTANTS.GET_TC, tcContent });
  }).catch((e) => {
    // eslint-disable-next-line no-console
    console.log('error', e);
  });
};

export const updateTC = (tcData) => (
  dispatch,
  getState,
  { getFirestore }
) => {
  dispatch({ type: CONSTANTS.UPDATE_TC });
  const firestore = getFirestore();
  const tcRef = firestore.collection(CONSTANTS.THEME).doc('termscondition');
  tcRef.update({
    content: tcData.content,
    dateUpdated: Date.now()
  }).then((data) => {
    dispatch({ type: CONSTANTS.UPDATE_TC_SUCCESS });
  }).catch((err) => {
    console.log('error', err)
  })
};